import { useCallback } from 'react';

import { ButtonIcon } from 'shared';

import { ScheduledForCallback } from 'features/chat/config/types/ScheduledMessage';
import { useShowScheduledModal } from 'features/chat/hooks/useShowScheduledModal';

import { ScheduleIcon } from './ScheduleIcon';

export const ChatMessageScheduleButton = ({
  onClick,
}: {
  onClick?: () => void;
}) => (
  <ButtonIcon
    name="schedule-message-btn"
    aria-label="schedule-message-btn"
    onClick={onClick}
  >
    <ScheduleIcon />
  </ButtonIcon>
);

export const ChatMessageScheduleButtonWithModalOpen = ({
  onSubmit,
  handleButtonClick,
}: {
  onSubmit: ScheduledForCallback;
  handleButtonClick?: () => void;
}) => {
  const showScheduledModal = useShowScheduledModal();

  const handleScheduleModalOpen = useCallback(() => {
    if (handleButtonClick) {
      handleButtonClick();
    }

    showScheduledModal(onSubmit);
  }, [onSubmit, handleButtonClick, showScheduledModal]);

  return <ChatMessageScheduleButton onClick={handleScheduleModalOpen} />;
};
